var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { attachProps } from "../../utils";
import SelectFieldSync from "./impl/SelectFieldSync";
import SelectFieldAsync from "./impl/SelectFieldAsync";
export * from "./types";
/** @component */
var SelectField = function (props) {
    // Fetch these props to sanity check search configuration.
    var searchable = props.searchable, searchValue = props.searchValue, onSearchValueChange = props.onSearchValueChange;
    // Remove async from props so we can pass the rest to the sync or async implementation.
    var async = props.async, rest = __rest(props, ["async"]);
    // Changing from sync to async or back is probably a bug, as they have mutually exclusive required properties.
    var asyncRef = React.useRef(async);
    var asyncWarned = React.useRef(false);
    React.useEffect(function () {
        if (!asyncWarned.current && asyncRef.current !== async) {
            asyncWarned.current = true;
            console.error("A MultiSelectField has changed its async mode while mounted.  This is not supported and may result in bugs.");
        }
    }, [async]);
    // The user might try to make search controlled but be unaware of the searchable property gating this feature.
    // Warn if the user tries to do this but does not specify the searchable property.
    // If the user wants to keep searchability disabled while supplying these properties,
    // they can explicitly set searchable to false, which suppresses this warning.
    var searchableWarned = React.useRef(false);
    React.useEffect(function () {
        if (searchableWarned.current === false &&
            searchable === undefined &&
            (searchValue !== undefined || onSearchValueChange !== undefined)) {
            searchableWarned.current = true;
            console.warn("SelectField: `searchValue` or `onSearchValueChange` was specified, but `searchable` was not specified and defaults to disabled.  If this is intentional, please set `searchable` to `false`.");
        }
    }, [searchable, searchValue, onSearchValueChange]);
    if (async) {
        return React.createElement(SelectFieldAsync, __assign({}, rest));
    }
    else {
        return React.createElement(SelectFieldSync, __assign({}, rest));
    }
};
function ofValueType() {
    return SelectField;
}
function ofItemType() {
    return SelectField;
}
export default attachProps(SelectField, {
    ofValueType: ofValueType,
    ofItemType: ofItemType
});
//# sourceMappingURL=SelectField.js.map